import { render, staticRenderFns } from "./outof_stock.vue?vue&type=template&id=27e60836"
import script from "./outof_stock.vue?vue&type=script&lang=js"
export * from "./outof_stock.vue?vue&type=script&lang=js"
import style0 from "./outof_stock.vue?vue&type=style&index=0&id=27e60836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports